// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import INITIAL_STATE from '../orderCreation/initialState.json';

export interface BillingAddressTypes {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    language: string;
    addressId: string;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    country: string;
    stateOrProvince: string;
    vatId: string;
    customerPO: string;
}

export type BillingAddressStoreType = Readonly<typeof INITIAL_STATE>;

export function _saveBillingAddressData(
    state: any,
    { payload }: { payload: any }
): BillingAddressStoreType {
    if (payload) {
        return {
            ...state,
            billingAddress: { ...payload },
        };
    }
    return state;
}
